<template>
  <q-dialog v-model="aberto" persistent>
    <q-card style="min-width: 490px; max-width: 500px; border-radius: 4px">
      <q-card-section class="row items-center q-pb-sm">
        <div>
          <div class="text-h6 text-weight-bold" style="color: #21324a">
            Criar Novo Risco
          </div>
          <div class="text-body2 text-grey-7 q-mt-xs">
            Preencha os dados para cadastrar um novo risco no sistema.
          </div>
        </div>
        <q-space />
        <q-btn class="q-mb-lg" icon="close" flat round dense @click="fechar" />
      </q-card-section>

      <q-card-section class="q-pt-md q-col-gutter-sm">
        <div>
          <div class="text-body2 text-weight-bold text-brand-5 q-mb-xs">
            Código *
          </div>
          <q-input
            v-model="form.code"
            dense
            outlined
            placeholder="Ex: R006"
            :rules="[(val) => !!val || 'Campo obrigatório']"
            ref="refCode"
          />
        </div>
        <div>
          <div class="text-body2 text-weight-bold text-brand-5 q-mb-xs">
            Nome *
          </div>
          <q-input
            v-model="form.name"
            dense
            outlined
            placeholder="Ex: Risco de Falha de Comunicação"
            :rules="[(val) => !!val || 'Campo obrigatório']"
            ref="refName"
          />
        </div>
      </q-card-section>

      <q-card-actions align="right" class="q-px-md q-pb-md q-pt-sm">
        <q-btn
          flat
          no-caps
          label="Cancelar"
          style="color: #21324a; border: 1px solid #21324a; border-radius: 4px"
          @click="fechar"
        />
        <q-btn
          no-caps
          label="Criar Risco"
          :loading="salvando"
          style="background-color: #1a73e8; color: white; border-radius: 4px"
          @click="salvar"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    vendorId: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ["update:modelValue", "risco-criado"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const aberto = ref(false);
    const salvando = ref(false);
    const refCode = ref(null);
    const refName = ref(null);

    const form = ref({
      code: "",
      name: "",
    });

    watch(
      () => props.modelValue,
      (val) => {
        aberto.value = val;
        if (val) {
          form.value = { code: "", name: "" };
        }
      }
    );

    watch(aberto, (val) => {
      if (!val) emit("update:modelValue", false);
    });

    const fechar = () => {
      aberto.value = false;
    };

    const salvar = async () => {
      const codeValido = refCode.value?.validate();
      const nameValido = refName.value?.validate();
      if (!codeValido || !nameValido) return;

      if (!props.vendorId) {
        quasar.notify({
          message: "Selecione uma Unidade antes de criar o risco.",
          color: "warning",
          position: "bottom",
        });
        return;
      }

      salvando.value = true;
      try {
        await store.dispatch("gestaoDeRiscos/criarRisco", {
          code: form.value.code,
          name: form.value.name,
          vendorId: props.vendorId,
        });

        quasar.notify({
          message: "Risco criado com sucesso!",
          color: "positive",
          position: "bottom",
          icon: "check_circle",
        });

        emit("risco-criado");
        fechar();
      } catch {
        quasar.notify({
          message: "Erro ao criar risco.",
          color: "negative",
          position: "bottom",
        });
      } finally {
        salvando.value = false;
      }
    };

    return {
      aberto,
      salvando,
      form,
      refCode,
      refName,
      fechar,
      salvar,
    };
  },
};
</script>
